<template lang="pug">
include ../../utils/picture.pug

.input.field.js-input.input--file(value="item.value")
    input(
        :id="item.id"
        type="file"
        :value="value"
        :placeholder="item.placeholder"
        v-on="listeners"
    ).input__el.clr-blue-22.trs.js-input-el
    span.input__file-text.trs
        +picture(`input__icon`, { svgName: `i-file`, isSVG: true, basePathParam: '/local/templates/renaissance/layout/dist/'})
        p(v-if="item.fileSelect == false") Выберите файл
        p(v-if="item.fileSelect == true") {{item.fileSelectName}}
</template>

<script>

  const filefield = {
    props: {
      item: {
        type: Object
      },
      value: {
        type: String,
        default: ''
      }
    },
    computed: {
      listeners () {
        return {
          // Pass all component listeners directly to input
          ...this.$listeners,
          // Override input listener to work with v-model
          input: event => this.$emit('input', event.target)
        }
      }
    }
  }

  export default filefield
</script>
